import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-job-offer',
  templateUrl: './alert-job-offer.component.html',
  styleUrls: ['./alert-job-offer.component.css']
})
export class AlertJobOfferComponent {

}
